import {
  ChangeDetectionStrategy,
  Component,
  effect,
  input,
  output,
  signal,
} from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { toSignal } from '@angular/core/rxjs-interop';
import { startWith } from 'rxjs';
import {
  CountryISO,
  NgxIntlTelInputModule,
  SearchCountryField,
  type ChangeData,
} from 'ngx-intl-tel-input';

export interface PhoneValue {
  country: string;
  number: string;
}

@Component({
  selector: 'om-phone-input',
  imports: [ReactiveFormsModule, NgxIntlTelInputModule],
  templateUrl: './phone-input.html',
  styleUrl: './phone-input.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PhoneInput {
  placeholder = input('');
  inputId = input('phone');

  phoneChange = output<PhoneValue>();

  readonly phoneCtrl = new FormControl<ChangeData | null>(null);
  readonly selectedCountryISO = signal<CountryISO>(CountryISO.UnitedStates);
  readonly preferredCountries: CountryISO[] = [
    CountryISO.UnitedStates,
    CountryISO.Spain,
    CountryISO.Portugal,
    CountryISO.Mexico,
  ];
  readonly searchCountryFields = [
    SearchCountryField.Name,
    SearchCountryField.DialCode,
    SearchCountryField.Iso2,
  ];

  private readonly phoneValue = toSignal(
    this.phoneCtrl.valueChanges.pipe(startWith(this.phoneCtrl.value)),
    { initialValue: this.phoneCtrl.value }
  );

  constructor() {
    effect(() => {
      const value = this.phoneValue();
      this.phoneChange.emit({
        country: (value?.countryCode ?? this.selectedCountryISO()).toUpperCase(),
        number: value?.internationalNumber ?? value?.number ?? '',
      });
    });
  }

  onCountryChanged(country: { iso2?: string } | null): void {
    const iso = country?.iso2?.toLowerCase();
    if (!iso) return;
    this.selectedCountryISO.set(iso as CountryISO);
  }
}
